<!-- <div class="container"> -->
  <form novalidate class="form-inline" [formGroup]="searchForm">
    <div class="form-group row justify-content-start">
      <!-- Autocomplete and button row -->
      <div class="col-12 col-md-9 notMobile">
        <div class="d-flex align-items-center">

          <!-- Autocomplete Component -->
          <span class="p-fluid flex-grow-1" id="navSearch" >
            <p-autoComplete inputId="keywords" placeholder="Enter Search Term(s) to Search - Searches Content & Properties" title="Enter Search Term(s) to Search - Searches Content & Properties" formControlName="keywords"
              id="keywords" ariaLabel="Keywords" [minLength]="3" [maxlength]="500" [showClear]="true" (onClear)="clearKeyword()"
              [suggestions]="aSugs" (completeMethod)="getSuggestions($event)"
              (onSelect)="kwSuggestionSelected($event)" size="small" styleClass="me-2"></p-autoComplete>
          </span>

          <!-- Search Button -->
          <p-button label="Search" icon="pi pi-search" styleClass="btn-secondary me-2 p-button-sm" (click)="submitForm();" [disabled]="!searchForm.valid || !isKeywordValid"  />
          <!-- <button type="submit" class="btn btn btn-secondary ms-2" (click)="submitForm();" [disabled]="!searchForm.valid">
            <i class="fas fa-search"></i> Search
          </button> -->
        </div>
      </div>
      <!-- Autocomplete and button row -->
      <div class="col-sm-12 forMobile">
        <div class="">

          <!-- Autocompelte Component -->
          <div class="p-fluid flex-grow-1">
            <p-autoComplete inputId="keywords" placeholder="Enter Keywords/Phrases to Search" formControlName="keywords"
              id="keywords" ariaLabel="Keywords" [minLength]="3" [maxlength]="500" [showClear]="true"
              [suggestions]="aSugs" (completeMethod)="getSuggestions($event)"
              (onSelect)="kwSuggestionSelected($event)"></p-autoComplete>
          </div>

          <!-- Search Button -->
           <div class="col-12 mt-2" style="text-align: center;">
          <button type="submit" class="btn btn btn-secondary ps-5 pe-5 mt-2" (click)="submitForm();" [disabled]="!searchForm.valid || !isKeywordValid">
            <i class="fas fa-search"></i> Search
          </button>
        </div>
        </div>
      </div>
    </div>
  </form>
<!-- </div> -->